import { bridge, isAndroid, isIOS, isNotNil, isWeb } from 'shared/src/utils';
import { useGoodsBasic } from './useGoodsBasic';
import { useEffect } from 'react';
import { useInstanceId, useOpenDeeplink } from 'shared/src/hooks';
import { useRootStackNavigation } from 'shared/src/hooks/useRootNavigation';

export const useCheckGoodsRedirectDeeplink = () => {
  const { data: goodsBasic, isSuccess } = useGoodsBasic();
  const { openDeeplink } = useOpenDeeplink();
  const instanceId = useInstanceId();
  const navigation = useRootStackNavigation();

  useEffect(() => {
    if ((isIOS || isAndroid) && isSuccess && isNotNil(goodsBasic)) {
      if (isNotNil(goodsBasic.redirect_deeplink)) {
        if (isIOS) bridge.closeInstance({ instanceId, animated: false });
        openDeeplink(goodsBasic.redirect_deeplink);
        if (isAndroid) bridge.closeInstance({ instanceId, animated: false });
      }
    }

    if (isWeb && isNotNil(goodsBasic)) {
      if (isNotNil(goodsBasic.redirect_weblink)) {
        location.href = goodsBasic.redirect_weblink;
      }
    }
  }, [goodsBasic, instanceId, isSuccess, navigation, openDeeplink]);
};
